import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { Company } from '../models/question-detail.model';
import { CompaniesResponseDto } from './dtos/question-detail.dto';

/**
 * `/invoice/companies` is owned by the invoice domain (see `InvoiceCompaniesApi`).
 * The question domain keeps its own copy per the cross-domain endpoint convention
 * in docs/project-architecture.md — question's business rules for this lookup
 * (a plain id/name list for the question form's company picker) differ from
 * invoice's own usage of the same endpoint.
 */
@Injectable({ providedIn: 'root' })
export class QuestionCompaniesApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;

  public companies(): Observable<Company[]> {
    return this._http
      .get<CompaniesResponseDto>(`${this._baseUrl}/invoice/companies`)
      .pipe(
        map((res) =>
          res.companies.map((company) => ({
            id: company.id,
            name: company.name,
          })),
        ),
      );
  }
}
